import { defineStore } from 'pinia';

import { i18n } from '@/i18n';
import { getMessagesByLocale } from '@/i18n/messages';

const initialLocale = localStorage.getItem('translation') || 'ru';

export const useLangStore = defineStore('lang', {
  state: () => ({
    translation: initialLocale,
    translations: getMessagesByLocale(initialLocale)
  }),
  actions: {
    changeLang(lang = 'ru') {
      const nextLang = lang === 'kz' ? 'kz' : 'ru';
      this.translation = nextLang;
      this.translations = getMessagesByLocale(nextLang);
      localStorage.setItem('translation', nextLang);
      i18n.global.locale.value = nextLang;
    }
  }
});
